import { featureFlagService } from 'utils/featureFlagService'
import LoadingScreen from '../components/Layout/LoadingScreen'
import { Navigate } from 'react-router-dom'

interface FeatureProtectedRouteProps {
  featureFlag: keyof ReturnType<typeof featureFlagService>
  children: React.ReactNode
}

export default function FeatureProtectedRoute({
  featureFlag,
  children,
}: FeatureProtectedRouteProps) {
  const featureFlags = featureFlagService()
  const isEnabled = featureFlags[featureFlag]

  if (featureFlags.isLoading) {
    return <LoadingScreen />
  }

  if (!isEnabled) {
    return <Navigate to="/dashboard" replace />
  }

  return <>{children}</>
}
